export const getFileExtension = (filename)=>{
    const lastDotIndex = filename.lastIndexOf(".");
    if (lastDotIndex === -1 || lastDotIndex === filename.length - 1) {
        return "";
    }
    return filename.slice(lastDotIndex + 1);
};
export const getDownloadFileName = (isOriginSellable, originFile)=>{
    if (!isOriginSellable || !originFile) {
        return "PDF";
    }
    const isHwpFamily = [
        "hwp",
        "hwpx"
    ].includes(getFileExtension(originFile));
    const fileType = isHwpFamily ? "HWP" : "DOC";
    return fileType;
};
